import { useEffect } from "react";

// mic lifecycle / silence escalation (spec: docs/superpowers/specs/2026-07-07-m3-continuous-conversation-requirements.md R3.1.4 / R3.8.4): タブ非表示中は continuous mode を pause。
// visibilitychange event を listen して callback を呼ぶ薄い hook。
type Options = {
  onHidden: () => void;
  onVisible: () => void;
};

export function useVisibilityPause({ onHidden, onVisible }: Options): void {
  useEffect(() => {
    const handler = () => {
      if (document.visibilityState === "hidden") onHidden();
      else if (document.visibilityState === "visible") onVisible();
    };
    document.addEventListener("visibilitychange", handler);
    return () => {
      document.removeEventListener("visibilitychange", handler);
    };
  }, [onHidden, onVisible]);
}
